import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_DETAIL_LABEL_WIDTH_PX,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_MUTED_COLOR,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import {
  NotePreviewDetailRow,
  NotePreviewPatientDetails,
} from "../note-preview-types";
import ReportSectionTab from "./ReportSectionTab";

export interface ReportPatientDetailsProps {
  patient: NotePreviewPatientDetails;
  /** Template name, visit type and mode, printed in grey under the grid. */
  visitLine: string;
}

const DetailColumn = ({ rows }: { rows: NotePreviewDetailRow[] }) => (
  <table
    style={{
      flex: "1 1 0",
      minWidth: 0,
      width: "50%",
      tableLayout: "fixed",
      borderCollapse: "collapse",
      fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
    }}
  >
    <colgroup>
      <col style={{ width: NOTE_PREVIEW_DETAIL_LABEL_WIDTH_PX }} />
      <col style={{ width: 12 }} />
      <col />
    </colgroup>
    <tbody>
      {rows.map((row) => (
        <tr key={row.label} style={{ breakInside: "avoid" }}>
          <td
            style={{
              color: NOTE_PREVIEW_MUTED_COLOR,
              padding: "2px 8px 2px 0",
              verticalAlign: "top",
            }}
          >
            {row.label}
          </td>
          <td
            style={{
              color: NOTE_PREVIEW_MUTED_COLOR,
              padding: "2px 6px 2px 0",
              verticalAlign: "top",
            }}
          >
            :
          </td>
          <td
            style={{
              color: NOTE_PREVIEW_TEXT_COLOR,
              padding: "2px 0",
              verticalAlign: "top",
            }}
          >
            {row.value}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

const ReportPatientDetails = ({
  patient,
  visitLine,
}: ReportPatientDetailsProps) => (
  <ReportSectionTab label={NOTE_PREVIEW_LABELS.patientDetails}>
    <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>
      <DetailColumn rows={patient.leftRows} />
      <DetailColumn rows={patient.rightRows} />
    </div>
    {visitLine && (
      <div
        style={{
          marginTop: 6,
          fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
          color: NOTE_PREVIEW_MUTED_COLOR,
        }}
      >
        {visitLine}
      </div>
    )}
  </ReportSectionTab>
);

export default ReportPatientDetails;
